/** Helpers for quoting / replying to a chat message (WhatsApp-style). */

const stripTags = (value = '') =>
  String(value)
    .replace(/<div[^>]*data-chat-reply[^>]*>[\s\S]*?<\/div>/gi, '')
    .replace(/<(.|\n)*?>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const escapeHtml = (value = '') =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

const unescapeHtml = (value = '') =>
  String(value)
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&')

export function getMessagePreview(message, maxLen = 120) {
  const text = stripTags(message?.text || message?.message || '')
  if (text) return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text
  if (message?.attachment || message?.contentType === 'image') return 'Attachment'
  return 'Message'
}

export function buildReplyTo(message) {
  if (!message || message.isTyping) return null
  if (message.contentType === 'system' || message.contentType === 'end' || message.contentType === 'bot') {
    return null
  }
  return {
    id: message.id,
    sender: message.sender || 'User',
    preview: getMessagePreview(message),
  }
}

export function wrapMessageWithReply(html, replyTo) {
  if (!replyTo) return html
  const sender = escapeHtml(replyTo.sender || 'User')
  const preview = escapeHtml(replyTo.preview || 'Message')
  const id = escapeHtml(String(replyTo.id || ''))
  const quote = `<div data-chat-reply="1" data-reply-id="${id}" data-reply-sender="${sender}"><strong>${sender}</strong><span>${preview}</span></div>`
  const body = html && String(html).trim() ? html : '<p></p>'
  return `${quote}${body}`
}

export function splitReplyHtml(html) {
  const raw = String(html || '')
  const match = raw.match(/<div[^>]*data-chat-reply="1"[^>]*>([\s\S]*?)<\/div>/i)
  if (!match) return { reply: null, bodyHtml: raw }
  const block = match[0]
  const senderAttr = (block.match(/data-reply-sender="([^"]*)"/i) || [])[1]
  const idAttr = (block.match(/data-reply-id="([^"]*)"/i) || [])[1]
  const sender = unescapeHtml(senderAttr || 'User')
  const preview =
    stripTags(
      match[1]
        .replace(/<strong[^>]*>[\s\S]*?<\/strong>/i, ' ')
        .replace(/<span[^>]*>/gi, '')
        .replace(/<\/span>/gi, ''),
    ) || 'Message'
  return {
    reply: {
      id: unescapeHtml(idAttr || ''),
      sender,
      preview,
    },
    bodyHtml: raw.replace(block, ''),
  }
}
